export default __webpack_public_path__ + "static/media/noPhoneFound.b79913f0.svg";